export enum Metric {
  GMV = 'GMV',
  ORDER_COUNT = 'ORDER_COUNT',
}

export default Metric;
